import { render, staticRenderFns } from "./SettingItemBox.vue?vue&type=template&id=6f7280b6&scoped=true"
import script from "./SettingItemBox.vue?vue&type=script&lang=js"
export * from "./SettingItemBox.vue?vue&type=script&lang=js"
import style0 from "./SettingItemBox.vue?vue&type=style&index=0&id=6f7280b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7280b6",
  null
  
)

export default component.exports